module.exports = __webpack_public_path__ + "static/media/salao_jardim_3.3d0193e6.jpg";